import { RouteConfig } from 'vue-router';

export const authChildren: Array<RouteConfig> = [
  {
    path: 'log-in',
    name: 'log-in',
    component: (): Promise<typeof import('vue')> => import(/* webpackChunkName: "auth" */ '../views/log-in/LogIn.vue')
  },
  {
    path: 'password-reset',
    name: 'password-reset',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "auth" */ '../views/password-reset/PasswordReset.vue')
  },
  {
    path: 'set-new-password/:token',
    name: 'set-new-password',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "auth" */ '../views/set-new-password/SetNewPassword.vue')
  },
  {
    path: '',
    redirect: { name: 'log-in' }
  }
];
